import { Duration, MultiplierTypeAttributes } from '@/types'
import { CreateMultiplierTypeMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'
import { useNavigate } from 'react-router'

interface Props {
  onSuccess: () => void
}

export const Form = ({ onSuccess }: Props) => {
  const navigate = useNavigate()

  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
    mutationData,
  } = useForm<CreateMultiplierTypeMutation, MultiplierTypeAttributes, never, never>({
    defaultValues: {
      name: '',
      multiplier: 1,
      multiplierType: Duration.Day,
      operandQuantity: 1,
      operandType: Duration.Day,
    },
    mutation: CreateMutation,
    resultKey: 'createMultiplierType',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  useEffect(() => {
    if (!mutationData?.createMultiplierType?.multiplierType?.id) return

    navigate(`/settings/charge-multipliers/${mutationData?.createMultiplierType?.multiplierType?.id}`)
  }, [mutationData, navigate])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      <div className="grid grid-cols-1 gap-6">
        { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
      </div>
      <div className="flex flex-row gap-6 w-full items-center">
        <span className="w-16">Charge</span>
        <div className="grow grid grid-cols-2 gap-6">
          { formBuilder.buildField({
            name: 'Multiplier',
            field: 'multiplier',
            type: 'positive-integer',
            hideLabel: true
          }) }
          { formBuilder.buildField({
            name: 'Multiplier type',
            field: 'multiplierType',
            type: 'multiplier-type',
            hideLabel: true
          }) }
        </div>
      </div>
      <div className="flex flex-row gap-6 w-full items-center">
        <span className="w-16">per</span>
        <div className="grow grid grid-cols-2 gap-6">
          { formBuilder.buildField({
            name: 'Operand quantity',
            field: 'operandQuantity',
            type: 'positive-integer',
            hideLabel: true
          }) }
          { formBuilder.buildField({
            name: 'Operand type',
            field: 'operandType',
            type: 'multiplier-type',
            hideLabel: true
          }) }
        </div>
      </div>

      <div className="flex flex-col">hire</div>
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
